import {
  AccountCircle,
  Assignment,
  AssignmentLate,
  AssignmentTurnedIn,
  BuildCircle,
  Dashboard,
  Description,
  EventNote,
  FlightTakeoff,
  Group,
  HouseSiding,
  LocalAirport,
  OtherHouses,
  // PendingActions,
  Settings,
  Support,
  UploadFile,
} from '@mui/icons-material';
import { rolesList, serviceRolesList, settingRolesList } from '@/helpers/roles';

import type { MenuItem } from '../components/auth/navigation';

const menu: MenuItem[] = [
  {
    text: 'Dashboard',
    icon: Dashboard,
    to: '/',
  },
  {
    text: 'Qualidade',
    icon: AssignmentTurnedIn,
    children: [
      {
        text: 'Gestão RIF',
        icon: Assignment,
        to: '/rif/management',
      },
      {
        text: 'RIF Realizados',
        icon: AssignmentTurnedIn,
        to: '/rif/concluded',
        roles: rolesList,
      },
      /* {
        text: 'Auditados Pendentes',
        icon: AssignmentLate,
        to: '/rif/pending',
        roles: rolesList,
      },
      {
        text: 'Confirmações Pendentes',
        icon: PendingActions,
        to: '/rif/pending-confirmations',
      }, */
    ],
  },
  {
    text: 'Gestão de Serviços',
    icon: Description,
    roles: serviceRolesList,
    children: [
      {
        text: 'Importação PCP',
        icon: UploadFile,
        to: '/service/upload',
      },
      {
        text: 'Serviços MNT',
        icon: BuildCircle,
        to: '/service/maintenance',
      },
      {
        text: 'Serviços de Apoio',
        icon: Support,
        to: '/service/support',
      },
    ],
  },
  {
    text: 'Configurações',
    icon: Settings,
    roles: settingRolesList,
    children: [
      {
        icon: AccountCircle,
        text: 'Usuários',
        to: '/setting/users',
      },
      {
        icon: Group,
        text: 'Perfis',
        to: '/setting/users/groups',
      },
      {
        icon: OtherHouses,
        text: 'Bases',
        to: '/setting/bases',
      },
      {
        icon: HouseSiding,
        text: 'Oficinas',
        to: '/setting/workshops',
      },
      {
        icon: LocalAirport,
        text: 'Aeronaves',
        to: '/setting/airplanes',
      },
      {
        icon: FlightTakeoff,
        text: 'Modelo de Aeronaves',
        to: '/setting/aircraft-models',
      },
      {
        icon: EventNote,
        text: 'Eventos Observados',
        to: '/setting/observed-events',
      },
    ],
  },
];

export default menu;
